var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var convertToViewModel = function (data) {
    var _a;
    return __assign(__assign({}, data), { isFree: data.isFree.toString(), isIndoor: data.isIndoor.toString(), sports: data.sports || [], cityId: data.city ? [data.city.id] : [], cityName: data.city ? data.city.name : "", coverFiles: ((_a = data.covers) === null || _a === void 0 ? void 0 : _a.map(function (cover) { return ({
            id: cover.fileId,
            url: cover.fileUrl,
            status: "uploaded",
            type: "image/",
        }); })) || [] });
};
